import {
  Button,
  Card,
  CardMedia,
  Container,
  Icon,
  makeStyles,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import axios from "axios";
import EXIF from "exif-js";
import Geohash from "latlon-geohash";
import L from "leaflet";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/leaflet.css";
import React, { ChangeEvent, useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { Map, Marker, TileLayer } from "react-leaflet";
import { v4 as uuidv4 } from "uuid";
import { useLocation, useRoute } from "wouter";
// @ts-ignore
import zipcodeJa from "zipcode-ja";
import firebase from "./firebase";
import { Store } from "./types";

const useStyles = makeStyles((theme) => ({
  margin: {
    marginBottom: "10px",
    marginTop: "20px",
  },
}));

const marker = new L.Icon({
  iconUrl: icon,
  iconSize: [25, 41],
  iconAnchor: [13, 41],
  popupAnchor: [0, -45],
  shadowUrl: iconShadow,
  shadowSize: [30, 60],
  shadowAnchor: [8, 60],
});

export default function Upload() {
  const [file, setFile] = useState<undefined | File>();
  const [preview, setPreview] = useState("/preview.png");
  const [gps, setGPS] = useState({ latitude: 0, longitude: 0 });
  const [latlng, setLatlng] = useState({ latitude: 0, longitude: 0 });
  const [open, setOpen] = useState(false);
  const [, setLocation] = useLocation();
  const [title, setTitle] = useState("");
  const classes = useStyles();
  const [fixPos, setFixPos] = useState(false);
  const [user, loading] = useAuthState(firebase.auth());
  const [isUpdate, updateParams] = useRoute("/upload/:id");
  const [loadingUpdate, setLoadingUpdate] = useState(true);
  const [storeId, setStoreId] = useState("");

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setGPS({ latitude, longitude });
        setLatlng({ latitude, longitude });
      });
    }

    if (isUpdate && updateParams) {
      const db = firebase.firestore();
      db.collection("store")
        .doc(updateParams.id)
        .get()
        .then(function (doc) {
          if (!doc.exists) {
            return;
          }
          setTitle(doc.data()!.title);
          setStoreId(doc.data()!.storeId);
        });
    }

    setLoadingUpdate(false);
  }, []);

  if (loading || loadingUpdate) {
    return <div />;
  }
  if (!user) {
    setLocation("/login");
  }

  const onMove = (event: any) => {
    const c = event.target.getCenter();
    setLatlng({ latitude: c.lat, longitude: c.lng });
  };

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    if (event.currentTarget.files) {
      const file = event.currentTarget.files[0];
      setFile(file);
      setPreview(URL.createObjectURL(file));
      var reader = new FileReader();

      reader.onloadend = function () {
        const ex = EXIF.readFromBinaryFile(reader.result);
        const Lat = ex.GPSLatitude;
        if (!Lat) return;

        const Lon = ex.GPSLongitude;
        const NS = ex.GPSLatitudeRef;
        const EW = ex.GPSLongitudeRef;
        const LatDeg = Lat.shift();
        const LatMin = Lat.shift();
        const LatSec = Lat.shift();
        const LonDeg = Lon.shift();
        const LonMin = Lon.shift();
        const LonSec = Lon.shift();
        let NDeg = (LatSec / 60 + LatMin) / 60 + LatDeg;
        let EDeg = (LonSec / 60 + LonMin) / 60 + LonDeg;

        if (NS === "S") NDeg = -NDeg;
        if (EW === "W") EDeg = -EDeg;
        if (isNaN(NDeg) || isNaN(EDeg)) return;

        setGPS({ latitude: NDeg, longitude: EDeg });
        setLatlng({ latitude: NDeg, longitude: EDeg });
      };

      reader.readAsArrayBuffer(file.slice(0, 100000));
    }
  };

  const handleSubmit = async () => {
    if (!file || gps.latitude === 0 || title === "" || !user) return;

    const response = await axios.get(
      `https://mreversegeocoder.gsi.go.jp/reverse-geocoder/LonLatToAddress?lat=${gps.latitude}&lon=${gps.longitude}`
    );
    const pos: any = Object.values(zipcodeJa).find(
      (x: any) => x.jisX0402 === response.data.results.muniCd
    );
    const place = pos.address.join("");
    const geohash = Geohash.encode(gps.latitude, gps.longitude);

    const id = uuidv4();
    const storage = firebase.storage();
    const path = "store/" + id;
    const storageRef = storage.ref().child(path);

    const metadata = {
      contentType: "image/jpeg",
      "Cache-Control": "public,max-age=3600",
    };
    await storageRef.put(file, metadata);

    const bucketName = "minnano-takeout.appspot.com";
    const imgURL = `https://firebasestorage.googleapis.com/v0/b/${bucketName}/o/${encodeURIComponent(
      path
    )}?alt=media`;
    const thumbURL = "";

    let sId = id;
    if (storeId !== "") {
      sId = storeId;
    }

    const data: Store = {
      id: id,
      storeId: sId,
      thumbnail: thumbURL,
      images: [imgURL],
      title: title,
      place: place,
      latitude: latlng.latitude,
      longitude: latlng.longitude,
      geohash: geohash,
      uid: user.uid,
      createdTime: firebase.firestore.FieldValue.serverTimestamp(),
    };

    const db = firebase.firestore();
    db.collection("store").doc(id).set(data);

    setLocation("/");
  };

  return (
    <Container maxWidth="sm">
      <div>
        <Typography className={classes.margin}>
          お店の名前と、テイクアウトのメニュー写真を投稿してください。
        </Typography>
        <TextField
          className={classes.margin}
          label="お店の名前"
          margin="normal"
          variant="outlined"
          value={title}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setTitle(e.target.value);
          }}
          fullWidth
        />
        <Button
          startIcon={<PhotoCamera />}
          className={classes.margin}
          component="label"
          fullWidth
          variant="contained"
        >
          写真アップロード
          <input
            type="file"
            accept="image/jpg,image/jpeg"
            style={{ opacity: 0, appearance: "none", position: "absolute" }}
            onChange={handleChange}
          />
        </Button>
        <Typography className={classes.margin}>写真プレビュー（クリックで拡大）</Typography>
        <Card
          style={{ height: "300px" }}
          onClick={() => {
            if (preview !== "/preview.png") setOpen(true);
          }}
        >
          <CardMedia style={{ height: "300px" }} image={preview}></CardMedia>
        </Card>
        {open && (
          <Lightbox
            mainSrc={preview}
            onCloseRequest={() => setOpen(false)}
            reactModalStyle={{
              overlay: {
                zIndex: 1200,
              },
            }}
          />
        )}
        <Typography className={classes.margin}>
          お店の場所（現在地、撮影場所が初期値です）
        </Typography>

        <FormControlLabel
          control={
            <Checkbox
              checked={fixPos}
              onChange={() => {
                setFixPos(!fixPos);
              }}
              name="fix-pos"
              color="primary"
            />
          }
          label="位置を修正する"
        />

        <Map
          dragging={fixPos}
          onMoveEnd={onMove}
          center={[gps.latitude, gps.longitude]}
          zoom={16}
          style={{ height: "300px" }}
        >
          <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={[latlng.latitude, latlng.longitude]} icon={marker}></Marker>
        </Map>
        <Button
          endIcon={<Icon>send</Icon>}
          component="label"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.margin}
          onClick={handleSubmit}
          disabled={!file || gps.latitude === 0 || title === "" || !user}
        >
          投稿
        </Button>
      </div>
    </Container>
  );
}
